import {
   sendTextMessage as sdkSendTextMessage,
   sendMediaFileMessage,
   editTextMessage,
   editMediaCaption,
} from '@/infrastructure/sdk';

/**
 * Message Service — wraps all SDK send calls.
 * Viewmodels and utils call this service; never call infrastructure/sdk directly from viewmodels.
 */

export const MessageService = {
   sendText: async ({ toJid, messageText, msgId, replyMessageId, mentionedUsersIds }) =>
      sdkSendTextMessage({ toJid, messageText, msgId, replyMessageId, mentionedUsersIds }),

   editText: async ({ newEditMessageId, messageId, editedTextContent, mentionedUsersIds }) =>
      editTextMessage({ newEditMessageId, messageId, editedTextContent, mentionedUsersIds }),

   editCaption: async ({ newEditMessageId, messageId, editedTextContent, mentionedUsersIds }) =>
      editMediaCaption({ newEditMessageId, messageId, editedTextContent, mentionedUsersIds }),

   sendMedia: async (params, progressCallback, successCallback, failureCallback) =>
      sendMediaFileMessage(params, progressCallback, successCallback, failureCallback),
};

export const sendMessage = async ({ chatId, text }) => sdkSendTextMessage({ toJid: chatId, messageText: text });

export const sendImage = async ({ chatId, file, caption }) =>
   sendMediaFileMessage({ toJid: chatId, fileMessageParams: { file, caption }, messageType: 'image' });

export const sendVideo = async ({ chatId, file, caption }) =>
   sendMediaFileMessage({ toJid: chatId, fileMessageParams: { file, caption }, messageType: 'video' });

export const sendAudio = async ({ chatId, file }) =>
   sendMediaFileMessage({ toJid: chatId, fileMessageParams: { file }, messageType: 'audio' });

export const sendFile = async ({ chatId, file }) =>
   sendMediaFileMessage({ toJid: chatId, fileMessageParams: { file }, messageType: 'file' });
